import { Downgraded, useHookstate } from '@hookstate/core'
import React, { useEffect } from 'react'
import { getStatisticsDispatchByEntryOriginService } from '~/features/Dispatch/services'
import PieChartMui from '~/components/PieChartMui'
import { addTotals } from '~/utils/format'

export default function DispatchByEntryOriginPieChart({
  operationId,
  initialDate,
  endDate,
  refresh,
  loading,
}) {
  const data = useHookstate([])

  useEffect(() => {
    loading.set(true)
    getStatisticsDispatchByEntryOriginService({
      operationId: operationId,
      initialDate: initialDate,
      endDate: endDate,
    })
      .then((response) => {
        // const result = response.map((responseData) => ({ item: responseData.name, value: responseData.total }))
        const result = response.map((responseData, index) => ({
          id: index,
          label: responseData.name,
          value: responseData.total,
          total: responseData.total,
        }))
        return data.set(result)
      })
      .finally(() => {
        loading.set(false)
      })
  }, [refresh])

  return (
    <PieChartMui
      data={data.attach(Downgraded).get()}
      title={'Graph of Occurrences by Entry Origin'}
      subtitle={`Total de ocorrência: ${addTotals(data.attach(Downgraded).get())}`}
      typeTotal={'Input Sources'}
      showPercent
    />
  )
}
